import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { DateService } from './date.service'

interface CdcCacheInterface {
  cachedTime: number,
  expired: number,
  data: any,
}

class CdcCache implements CdcCacheInterface {

  cachedTime: number;
  expired: number;
  data: any;

  constructor(params) {
    this.cachedTime = params.cachedTime
    this.expired = params.expired
    this.data = params.data
  }

  isExist(): boolean {
    if (this.data instanceof Array) {
      return this.data.length > 0
    }
    return this.data;
  }
 
}

@Injectable()
export class DataCacheService {

  constructor(
    private _storage: Storage,
    private _dateService: DateService,
  ) {
  }

  async get(key) {

    let data = await this._storage.get(key)
    // データがなければnullで返す
    if (!data) return new CdcCache({})

    let _data = new CdcCache({expired: data.expired, data: data.data, cachedTime: data.cachedTime})

    // キャッシュ期限が現在時刻よりも古い場合、
    // キャッシュ削除して、nullを返す
    if (this._dateService.now > _data.expired) {
      this.remove(key);
      return new CdcCache({})
    }
    return _data;
  }

  async set(key, data, expired) {
    let _data: CdcCacheInterface = {
      cachedTime: this._dateService.now,
      expired: expired,
      data: data
    };
    await this._storage.set(key, _data)
    return _data
  }

  async remove(key) {
    return this._storage.remove(key)
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-cache.service.ts